import { motion } from "framer-motion";
import { useState } from "react";
import { Reveal, Overline } from "./Reveal";
import { TARGET_INDUSTRIES } from "../../data/content";

export const Ambitions = () => {
  const [active, setActive] = useState(0);

  return (
    <section id="ambitions" className="relative bg-[#0c2c20] py-28 md:py-40">
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 max-w-3xl">
          <Overline>05 — Where I&apos;m Headed</Overline>
          <h2 className="mt-6 font-display text-4xl font-bold leading-[1.05] text-white sm:text-5xl lg:text-6xl">
            The next chapter,
            <span className="font-serif-e italic text-[#c9a24e]"> by design.</span>
          </h2>
          <p className="mt-6 max-w-xl text-[15px] leading-relaxed text-[#a1a1aa]">
            Actively seeking partnerships, investment and leadership roles across the sectors where
            operational rigour and commercial ambition create lasting value.
          </p>
        </div>

        <div className="border-t border-white/10">
          {TARGET_INDUSTRIES.map((ind, i) => (
            <Reveal key={ind.name} delay={0.04 * i}>
              <div
                data-testid={`ambition-${i}`}
                onMouseEnter={() => setActive(i)}
                className="group grid grid-cols-1 items-center gap-4 border-b border-white/10 py-8 transition-colors duration-500 hover:bg-[#184a34]/50 md:grid-cols-12 md:py-10"
              >
                <span className="font-serif-e text-2xl italic text-white/20 transition-colors duration-500 group-hover:text-[#c9a24e] md:col-span-1">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h3 className="font-display text-3xl font-bold leading-none text-[#52525b] transition-colors duration-500 group-hover:text-white md:col-span-7 md:text-5xl lg:text-6xl">
                  {ind.name}
                </h3>
                <motion.p
                  animate={{ opacity: active === i ? 1 : 0.4 }}
                  className="text-sm leading-relaxed text-[#a1a1aa] md:col-span-4"
                >
                  {ind.note}
                </motion.p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
